import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import _ from 'lodash';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from '../common/react-redux-hooks';
import CacToolPalette from './CacToolPalette';
import CacMainContainer from './CacMainContainer';
import { 
  getCACProjectDetails, 
  handleViewSwitch, 
  getClusterProjectDetails, 
  getCACProjectContourMap } from '../../actions/cacActions';
import { CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT, HANDLE_VIEW_SWITCH_EVENT, CAC_LEFT_PANEL_VIEW_LABEL } from './CacConstants';
import { getApiRequestParameter } from '../../util/cacUtils';

function CacProjectContent(props) {
  const { userId, currentAccountId } = useSelector(state => state.login.loginResponse.data);
  const { projectId, leftPanel, corrResponse, contourMap, study, rows, columns } = props.project;

  const projectObj = getApiRequestParameter(props.project);

  const dispatch = useDispatch();

  const handleviewChange = (activeView, activeProjectId) => {
    dispatch(handleViewSwitch(activeView, activeProjectId));
    if(activeView === CAC_LEFT_PANEL_VIEW_LABEL) {
      const projectObj = getApiRequestParameter(props.project, activeView, '', HANDLE_VIEW_SWITCH_EVENT);
      dispatch(getCACProjectDetails({ userId, currentAccountId, ...projectObj }));
      dispatch(getClusterProjectDetails({ userId, currentAccountId, ...projectObj }));
      // dispatch(getCACProjectContourMap({ userId, currentAccountId, ...projectObj }));  // jed
    }
  };

  const handleViewDisable = () => {
    const filteredRows = rows.filter(row => !row.isPassive);
    const filteredColumns = columns.filter(col => !col.isPassive);
    if (filteredRows.length >= CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT &&
      filteredColumns.length >= CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT) {
      return false;
    }
    return true;
  };

  // const loadData = () => {
  //   return (dispatch) =>  new Promise (() => {
  //     console.log("AT ONE");
  //     dispatch(getClusterProjectDetails({ userId, currentAccountId, ...projectObj }));
  //   }).then(() => {
  //       console.log('AT ONE');
  //     dispatch(
  //       getCACProjectContourMap({ userId, currentAccountId, ...projectObj })
  //     )
  //   }).catch((e) => {
  //     console.log("ERROR", e);
  //   })
  // }

  React.useEffect(() => {
    if (isEmpty(corrResponse) && !isEmpty(study) && rows.length > 2 && columns.length > 2) {
      dispatch(getCACProjectDetails({ userId, currentAccountId, ...projectObj }));
      dispatch(getClusterProjectDetails({ userId, currentAccountId, ...projectObj }));
      // dispatch(getCACProjectContourMap({ userId, currentAccountId, ...projectObj }));  // jed
    }
  }, [props.activeProjectId]);

  return (
    <div className="projectContent">
      <CacToolPalette
        selectedView={leftPanel}
        projectId={projectId}
        handleViewSwitch={handleviewChange}
        isViewDisable={handleViewDisable()}
      />
      <CacMainContainer
        project={projectObj}
        redrawChart={false}
      />
    </div>
  );
}

CacProjectContent.propTypes = {
  project: PropTypes.shape({
    leftPanel: PropTypes.string,
    study: PropTypes.instanceOf(Object),
    rows: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.object),
    base: PropTypes.arrayOf(PropTypes.object),
    isBaseOpen: PropTypes.bool,
    isRowsOpen: PropTypes.bool,
    isColumnsOpen: PropTypes.bool,
    isPassivesOpen: PropTypes.bool,
    projectId: PropTypes.number,
    corrMapView: PropTypes.bool,
    chartView: PropTypes.instanceOf(Array),
    passiveRows: PropTypes.arrayOf(PropTypes.number),
    passiveCols: PropTypes.arrayOf(PropTypes.number),
    corrResponse: PropTypes.shape({
      cm: PropTypes.instanceOf(Object)
    }),
    contourMap: PropTypes.shape({
      cm: PropTypes.instanceOf(Object)
    }),
    clusterBy: PropTypes.string,
  }),
  activeProjectId: PropTypes.number,
};

export default memo(CacProjectContent);
